import React from 'react';


interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  overlay?: boolean;
  text?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 'medium',
  overlay = true,
  text,
}) => {
  const spinnerContent = (
    <>
      <div className={`spinner ${size}`} />
      {text && <div className="spinner-text">{text}</div>}
    </>
  );

  if (overlay) {
    return (
      <div className="spinner-overlay">
        <div className="spinner-container">{spinnerContent}</div>
      </div>
    );
  }

  return <div className="spinner-container">{spinnerContent}</div>;
};

export default Spinner;
